import { useEffect, useState } from 'react'
import TabDescription from './TabDescription'

export const PRODUCT_TABS = {
  DETAILS: 0,
  REVIEWS: 1
} as const

const ProductTabs = ({ data, activeTabIndex, onTabChange }: { data: any, activeTabIndex: number, onTabChange: (index: number) => void }) => {
  const tabIndex = activeTabIndex
  const setTabIndex = onTabChange
  const [hasMounted, setHasMounted] = useState(false)

  const bvProductdId = data.dg_root_sv

  useEffect(() => {
    setHasMounted(true)
  }, [])

  return (
    <div className="product-tabs">
      <div className="tabs">
        <ul role="tablist" className="tabs__tab-list">
          <li role="presentation" className="tabs__tab-list-item">
            <button
              onClick={() => setTabIndex(0)}
              className={`btn__link tabs__trigger${tabIndex === 0 ? ' is-selected' : ''}`}
              aria-selected={tabIndex === 0}
              role="tab"
              id='detailsTab'
            >
              Details
            </button>
          </li>
          <li role="presentation" className="tabs__tab-list-item">
            <button
              onClick={() => setTabIndex(1)}
              className={`btn__link tabs__trigger${tabIndex === 1 ? ' is-selected' : ''}`}
              aria-selected={tabIndex === 1}
              role="tab"
              id='reviewsTab'
            >
              Ratings &#38; Reviews
            </button>
          </li>
        </ul>
        <div className="tabs__panels">
          <section
            data-testid="tabpanel-details"
            aria-labelledby='detailsTab'
            key="tabs__panel-details"
            role="tabpanel"
            data-tabindex={tabIndex}
            aria-hidden={tabIndex !== 0}
            className="tabs__panel"
            style={hasMounted && tabIndex !== 0 ? { display: 'none' } : undefined}
          >
            <TabDescription data={data} />
          </section>
          <section
            data-testid="tabpanel-reviews"
            aria-labelledby='reviewsTab'
            key="tabs__panel-reviews"
            data-tabindex={tabIndex}
            aria-hidden={tabIndex !== 1}
            className="tabs__panel"
            style={hasMounted && tabIndex !== 1 ? { display: 'none' } : undefined}
          >
            <div data-bv-show="reviews" data-bv-product-id={bvProductdId}></div>
          </section>
        </div>
      </div>
    </div>
  )
}

export default ProductTabs
